<ng-container *transloco="let t">
    <div class="full-screen" [class.dark-theme]="darkMode" [class.light-theme]="!darkMode">
        <div class="content">
            @if (race && competitorResult) {
            <div class="results">
                <div class="close-icon" (click)="back()">
                   <i class="bi bi-x-lg"></i>
                </div>
                <div class="race-row font-size-l">
                    <ng-template [ngTemplateOutlet]="eventName"/>
                </div>
                <div class="event-row font-size-sm">
                    @if (race.sport) {
                        {{t("app.common.sports." + race.sport)}}
                    }
                    <div class="divider"></div>
                        <span class="accent">
                            {{ race.raceStart | localizedDate:"shortDate" }}
                        </span>
                    </div>
                <div class="stats-divider"></div>
                <div class="results-section">
                    <div class="competitor">
                        @if (isTeam) {
                            <div class="competitor-name font-size-md">
                                {{ t("app.common.team") + " " + ((competitorResult?.lastName ?? '' ) | uppercase) }}
                            @if (sameCountry && teamCountry) {
                                <span [class]="'ps-2 fi fi-' + (teamCountry | country:'isoCode' | lowercase)"></span>
                            }
                            </div>
                            <div class="team-members font-size-sm">
                                @for (member of competitorResult?.competitorResultsDetail?.team; track member.id) {
                                    <div class="team-member">
                                        {{
                                        ((member?.fn ?? "") | titlecase) + " " + ((member?.ln ?? "") | titlecase)
                                         }}
                                         @if (!sameCountry && member.cty) {
                                            <span [class]="'ps-2 fi fi-' + (member.cty | country:'isoCode' | lowercase)"></span>
                                        }
                                    </div>
                                }
                            </div>

                        }
                        @else {
                            <div class="competitor-name font-size-l">
                                {{ ((competitorResult?.firstName ?? '' ) | uppercase) + " " + ((competitorResult?.lastName ?? '' ) | uppercase) }}
                                @if (competitorResult.country) {
                                        <span [class]="'ps-2 fi fi-' + (competitorResult.country | country:'isoCode' | lowercase)"></span>
                                }
                            </div>
                        }
                        <span class="event-row accent font-size-sm">
                            <ng-template [ngTemplateOutlet]="raceName" [ngTemplateOutletContext]="{ r: race}"/>
                        </span>
                    </div>
                    <div class="stats-divider"></div>
                    <div class="stats">
                           <div class="d-flex flex-column align-items-center">
                                <div class="stat-label accent font-size-sm">{{t('competitor.table.time')}}</div>
                                <div class="stat-value font-size-l">
                                    {{competitorResult?.competitorResultsDetail | resultsTotalTime:race?.raceSettings?.measurementType:race?.raceSettings?.measurementPrecisionType}}
                                </div>
                            </div>
                           <div class="stat-divider"></div>
                            <div class="d-flex flex-column align-items-center">
                                <div class="stat-label accent font-size-sm">{{t("competitor.table.absolute.rank")}}</div>
                                <div class="stat-value stat-value-accent font-size-l">
                                    #{{(competitorResult?.categoryRank || competitorResult?.sexRank || competitorResult?.absoluteRank) ?? '-'}}
                                </div>
                                 <div class="stat-sublabel font-sixe-xs">{{t("app.common.overall")}}</div>
                            </div>
                    </div>
                </div>
            </div>
            }
            @else {
            <div class="selection">
                @if (races.length) {
                    <div ngbDropdown class="dropdown-field" #raceDropdown="ngbDropdown">
                        <button class="dropdown-field-toggle" ngbDropdownToggle>
                            <div class="d-flex justify-content-between">
                            <div>
                                <i class="bi bi-flag dropdown-field-icon px-3"></i>
                                @if (race) {
                                    {{t('app.common.race')}} - <ng-template [ngTemplateOutlet]="raceName" [ngTemplateOutletContext]="{ r: race}"/>
                                } @else {
                                {{ t('liveResults.photoPoint.selectRace') }}
                                }
                            </div>
                            <div>
                                <i class="bi color-grey-neutral-400" [ngClass]="raceDropdown.isOpen() ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                            </div>
                            </div>
                        </button>
                        <div ngbDropdownMenu>
                            @for (r of races; track r.id) {
                                <button ngbDropdownItem [class.active]="race?.id === r.id"
                                    (click)="selectRace(r)">
                                    <ng-template [ngTemplateOutlet]="raceName" [ngTemplateOutletContext]="{ r: r}"/>
                                </button>
                                }
                        </div>
                    </div>
            }
            <div ngbDropdown #competitorDropdown="ngbDropdown" class="dropdown-field">
             <button class="dropdown-field-toggle">
                 <div class="d-flex justify-content-start">
                         <i class="bi bi-search dropdown-field-icon px-3"></i>
                         <input type="text" class="dropdown-field-input"
                             [ngModel]="searchTerm" (ngModelChange)="onInput($event)"
                             (focus)="onFocus()" [placeholder]="t('liveResults.photoPoint.selectCompetitor')"/>
                  </div>
             </button>
             <div ngbDropdownMenu>
                 @for (result of searchResults; track result) {
                <button ngbDropdownItem [class.active]="competitorResult?.id === result.id" (click)="selectCompetitor(result)">
                @if (result.startNumber) {
                <span class="dropdown-field-badge">{{ result.startNumber }}</span>
                }
                {{
                   (isTeam ? t("app.common.team"): ((result?.firstName ?? '' ) | titlecase)) + " " + ((result?.lastName ?? '' ) | titlecase)
                }}
                </button>
                }
                </div>
            </div>
            </div>
            }
        </div>
        <div class="logo-container">
            <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey" (click)="goToLiveResults()"/>
        </div>
    </div>

    <ng-template #eventName>
        <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng"
                             [itLabel]="event?.nameIta" [siLabel]="event?.nameSlo" [bsLabel]="event?.nameBs"
                             [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
    </ng-template>
    <ng-template #raceName let-r="r">
        <app-language-output [hrLabel]="r?.name" [srLabel]="r?.nameSr" [enLabel]="r?.nameEng"
                             [itLabel]="r?.nameIta" [siLabel]="r?.nameSlo" [bsLabel]="r?.nameBs"
                             [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
    </ng-template>
</ng-container>